let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ljJO5")).then(() => parcelRequire('4j6e5'));